import React from "react";
import PropTypes from "prop-types";
import ErrorBoundary from "../error_boundary";
import GetQwotedCTA from "../profiles/GetQwotedCTA";
import MediaProfile from "./MediaProfile";
import { MediaProfileProvider } from "./data/media_profile_context_management";

// Registered entry point for the Media Profile show page (mirrors PrProfileTopLevelShow): wraps the
// provider + error boundary around the show. The ERB mounts this component by name.
function MediaProfileTopLevelShow({ mediaProfileId, viewerContext = undefined }) {
  const contextValue = { viewerContext };

  return (
    <MediaProfileProvider value={contextValue}>
      <ErrorBoundary>
        <MediaProfile mediaProfileId={mediaProfileId} />
      </ErrorBoundary>
      {!viewerContext?.isAuthenticated && <GetQwotedCTA />}
    </MediaProfileProvider>
  );
}

MediaProfileTopLevelShow.propTypes = {
  mediaProfileId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  viewerContext: PropTypes.shape({
    editable: PropTypes.bool,
    isSelf: PropTypes.bool,
    isAuthenticated: PropTypes.bool,
    planPaid: PropTypes.bool,
    role: PropTypes.string,
    upgradeUrl: PropTypes.string,
  }),
};

export default MediaProfileTopLevelShow;
